import { FC } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Box, Card, CardContent } from "@mui/material";
import { Link } from "react-router-dom";

import Divider from "@mui/material/Divider";
import "./SCUIHomeDashboardCard.scss";

interface IProps {
  headText: string;
  context: string;
  componentName?: string;
  pastReviewList?: Array<{ date: string; desc: string }>;
}

export const SCUIHomeDashboardCard: FC<IProps> = ({
  headText = "",
  context = "",
  componentName = " ",
}) => {
  return (
    <Card>
      <CardContent>
        <Grid
          container
          spacing={3}
          sx={{ height: "5rem", alignContent: "center" }}
        >
          <Grid>
            {/* <Avatar>
               {headText.charAt(0)}
          
            </Avatar> */}
          </Grid>
          <Grid>
            <Typography color="textSecondary" variant="h6">
              {headText}
            </Typography>
            <Typography
              color="textPrimary"
              variant="h4"
              style={{ justifyContent: "center" }}
            >
              {context}
            </Typography>
          </Grid>
        </Grid>
        <Divider />
        <Box
          sx={{
            pt: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Link
            to={componentName}
            className="sign-in-link"
            style={{ color: "#427ef5" }}
          >
            {headText}
            {/* <ArrowForwardIcon/> */}
          </Link>
        </Box>
      </CardContent>
    </Card>
  );
};
